const locale: Locale = {
  ko: {
    wait: '잠시만 기다려주세요...',
  },
  en: {
    wait: 'please wait a second...',
  },
}

export default locale
